import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';
import { uiTransitionDurationShort } from 'common/styles/variables';
import BackArrowNav from 'common/icons/BackArrowNav';

export const TitleContainer = styled.div`
    display: grid;
    grid-template-columns: 2rem 1fr 2rem;
    column-gap: 1rem;
    text-align: center;
    align-items: center;
`;

export const EditElementMenuStyles = styled(SuiContainer)`
    background-color: ${({ theme }) => theme.palette.grayscale.white};
    transition: 0.2s all;
    transform: translateX(${({ isOpened }) => (isOpened ? '-100%' : '0%')});
    padding: 20px;
`;

export const StyledBackArrowNav = styled(BackArrowNav)`
    cursor: pointer;
    color: ${({ theme }) => theme.palette.grayscale.gray65};
    transition: color ${uiTransitionDurationShort} ease;

    &:hover {
        color: ${({ theme }) => theme.palette.grayscale.black};
    }
`;

export const LoadingSpinnerContainer = styled.div`
    display: flex;
    padding-top: 10vh;
    align-items: center;
    justify-content: center;
`;
